/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Many_Fuzzy_Moth_ReapInputs */

const fr_many_fuzzy_moth_reap = /** @type {(inputs: Many_Fuzzy_Moth_ReapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter un utilisateur`)
};

/**

* @param {Many_Fuzzy_Moth_ReapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const many_fuzzy_moth_reap = /** @type {((inputs?: Many_Fuzzy_Moth_ReapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Many_Fuzzy_Moth_ReapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_many_fuzzy_moth_reap(inputs)
});